
Greenmile.PanelBuilder = Greenmile.PanelBuilder || {};

Greenmile.PanelBuilder.CardView = function () {

    Greenmile.PanelBuilder.Card.apply(this, arguments);

    this.elBackView = document.createElement("div");
    this.elBackView.setAttribute('class', 'Card BackCard');

    this.elFrontView = document.createElement("div");
    this.elFrontView.setAttribute('class', 'Card FrontalCard');

    this.fieldList = [];
    this.viewerFieldList = [];

    this.elCard = document.createElement("div");

    this.updateCard = function (cardField) {

        if (cardField.field.name || cardField.field.getValue) {
            if (cardField.field.getValue) {
                var entityField = cardField.field.getValue();
                cardField.attribute = entityField.name;
                if (entityField.lookupEntity) {
                    cardField.attribute += "." + entityField.lookupEntityColumn;
                }
            } else {
                cardField.attribute = cardField.field.name;
            }

            var founded = this.viewerFieldList.reduce(function (returned, viewer) {
                if (viewer.isFront === cardField.isFront && viewer.fieldPosition === cardField.fieldPosition) {
                    returned = viewer;
                }
                return returned;
            }, null);

            if (founded) {
                founded.setValue(cardField);
                founded.update(cardField);
            }
        }
    };


    this._renderFrontal = function (el, description, routeView) {
        el.innerHTML = "";
        el.appendChild(this.buildDate(routeView));
        el.appendChild(this.getStatus(routeView));
        el.appendChild(description);
    };

    this.renderFrontalView = function (routeView) {

        this.viewerFieldList
            .filter(function (field) {
                return field.isFront;
            })
            .forEach(function (cardViewer) {

                cardViewer.routeView = routeView;

            }, this);

        return this.elFrontView;

    };

    this.renderBackView = function (routeView) {

        this.viewerFieldList
            .filter(function (field) {
                return field.isFront === false;
            })
            .forEach(function (cardViewer) {

                cardViewer.routeView = routeView;

            }, this);

        return this.elBackView;

    };

    this.getValue = function () {
        return this.fieldList;
    };

    this.destroyCard = function () {
        var parent = this.elCard.parentNode;
        if (parent) {
            parent.removeChild(this.elCard);
        }
    };


    this.createStructure = function (routeView) {
        let selectContainer = document.createElement('div');

        [1, 2, 3].forEach( (fieldPosition) => {
            var viewer = new Greenmile.PanelBuilder.CardFieldViewer({
                fieldPosition: fieldPosition,
                isFront: true
            });
            this.viewerFieldList.push(viewer);
            selectContainer.appendChild(viewer.render());
        });

        this._renderFrontal(this.elFrontView, selectContainer, routeView || {});
        this.elBackView.appendChild(this.getStatus(routeView));

        this.elBackView.appendChild(this.createGoToRouteDetails(routeView));

        [1, 2, 3, 4, 5].forEach(function (fieldPosition) {

            var field = new Greenmile.PanelBuilder.CardFieldViewer({
                fieldPosition: fieldPosition,
                isFront: false
            });
            this.viewerFieldList.push(field);

            this.elBackView.appendChild(field.render("description" + fieldPosition));

        }, this);

    };

    this.flipCard = (element) => {
        let showBackClass = "ShowBack";
        if (element.className.indexOf(showBackClass) !== -1) {
            element.className = element.className.replace(showBackClass, "").trim();
        } else {
            element.className += ` ${showBackClass}`;
        }

    };

    this.render = function(fields, routeView, color, flip) {

        fields.forEach(function(field) {

            const viewer = new Greenmile.PanelBuilder.CardFieldViewer(field);
            viewer.routeView = routeView;
            this.viewerFieldList.push(viewer);

            if(viewer.isFront) {
                const frontCardHasElements = this.elFrontView.childNodes.length;
                
                if(frontCardHasElements === 0) {
                    this._renderFrontal(this.elFrontView, viewer.render(), routeView);
                } else {
                    this.elFrontView.appendChild(viewer.render());
                }
            } else {
                this.elBackView.appendChild(this.createGoToRouteDetails(routeView));
                this.elBackView.appendChild(viewer.render("description" + viewer.fieldPosition));
            }

        }, this);

        var Flip = document.createElement("div");

        this.elCard.className = "CardFlip";
        Flip.className = "CardFlipper";
        this.elFrontView.className += ' CardFront';

        this.elFrontView.style.background = color.cardColor;
        this.elBackView.style.background = color.cardColor;

        this.elFrontView.style.color = color.fontColor;
        this.elBackView.style.color = color.fontColor;

        Flip.appendChild(this.elFrontView);
        Flip.appendChild(this.elBackView);

        this.elCard.appendChild(Flip);

        if (flip) {
            this.elCard.className += " ShowBack";
        }

        this.elCard.addEventListener("click", () => ( this.flipCard(this.elCard) ) );

        return this.elCard;

    };

};